import {connect} from 'react-redux'
import ViewUrlModalPanel from '../components/modal-panels/view-url-modal-panel'

function mapStateToProps (state) {
  return {
    ...state.app.request,
  }
}

export default connect(mapStateToProps)(ViewUrlModalPanel)



// WEBPACK FOOTER //
// ./src/containers/view-url-modal-panel-container.js